import { SectionEyebrow } from "@/components/ui/SectionEyebrow";

export function InfrastructureIntro() {
  return (
    <section className="mx-auto max-w-4xl px-5 py-20 text-center lg:px-8">
      <SectionEyebrow>One Infrastructure Partner</SectionEyebrow>
      <h2 className="mt-5 font-display text-3xl font-semibold text-text-primary sm:text-4xl">
        Everything Your Digital Business Needs to Stay Online and Keep Growing
      </h2>
      <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-text-secondary">
        From individual virtual servers to dedicated infrastructure, cloud deployments, secure
        communication and network protection, The Planet brings essential business infrastructure
        together under one platform.
      </p>
    </section>
  );
}
